import { OnInit, Input, ViewChild } from '@angular/core';
import { ControlValueAccessor, DefaultValueAccessor, NgControl } from '@angular/forms';
import { MatInput } from '@angular/material';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';

export abstract class BaseInputComponent implements OnInit, ControlValueAccessor {

  @Input() label: string;
  @Input() required: boolean;
  @Input() hint?: string;
  @Input() errorMessage?: string;
  @ViewChild(DefaultValueAccessor) private valueAccessor: DefaultValueAccessor;
  @ViewChild(MatInput) protected matInput: MatInput;

  constructor(
    protected ngControl: NgControl,
    protected fieldConventionService: FieldConventionService,
    protected validationMessageService: ValidationMessageService) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    this.matInput.ngControl = this.ngControl;

    if (!this.label) {
      this.label = this.fieldConventionService.getDefaultLabel(this.ngControl.name);
    }
  }

  writeValue(obj: any): void {
    this.valueAccessor.writeValue(obj);
  }

  registerOnChange(fn: any): void {
    this.valueAccessor.registerOnChange(fn);
  }

  registerOnTouched(fn: any): void {
    this.valueAccessor.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.valueAccessor.setDisabledState(isDisabled);
  }

  getErrorMessage() {
    if (this.errorMessage) {
      return this.errorMessage;
    }

    return this.validationMessageService.getMessage(this.label, this.ngControl.errors);
  }
}
